import { TYPE_AVERAGE, TYPE_SUM } from "@/helpers/constants";
import { configNumberFormatter, formatters } from "@/helpers/formatters";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  {
    title: "Acquisitions",
    value: "acquisitions",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Acquisition",
  },
  {
    title: "App Events",
    value: "app_events",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "App Event",
  },
  {
    title: "App Installs",
    value: "app_installs",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "App Install",
  },
  {
    title: "Bookings",
    value: "bookings",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Booking",
  },
  {
    title: "Clicks",
    value: "clicks",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
  },
  {
    title: "Completed Views",
    value: "completed_views",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
  },
  {
    title: "CPA",
    value: "cpa",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Acquisition",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPAE",
    value: "cpae",
    formatter: formatters.currencyFormat,
    kpiTrigger: "App Event",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPB",
    value: "cpb",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Booking",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPC",
    value: "cpc",
    formatter: formatters.currencyFormat,
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPCV",
    value: "cpcv",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Video View",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPE",
    value: "cpe",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Engagement",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPER",
    value: "cper",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Event Response",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPI",
    value: "cpi",
    formatter: formatters.currencyFormat,
    kpiTrigger: "App Install",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPL",
    value: "cpl",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Lead Gen",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPIA",
    value: "cpia",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Intent Action",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPLA",
    value: "cpla",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Local Action",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPLC",
    value: "cplc",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Link Click",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPLV",
    value: "cplv",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Landing Page Visit",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPM",
    value: "cpm",
    formatter: formatters.formattedCurrencyTwoDecimals,
    kpiTrigger: "Impression",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPP",
    value: "cpp",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Purchase",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPPL",
    value: "cppl",
    formatter: formatters.currencyFormat,
    calculationType: TYPE_AVERAGE,

    kpiTrigger: "Page Like",
  },
  {
    title: "CPS",
    value: "cps",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Submission / Entry",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPSA",
    value: "cpsa",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Website Action",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPSV",
    value: "cpsv",
    formatter: formatters.currencyFormat,
    kpiTrigger: "Store Visit",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CTR",
    value: "ctr",
    formatter: formatters.percentFormat,
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "Engagements",
    value: "engagements",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Engagement",
  },
  {
    title: "Event Response",
    value: "event_response",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Event Response",
  },
  {
    title: "Impressions",
    value: "impressions",
    formatter: formatters.plainNumberWithSeparators,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Impression",
  },
  {
    title: "Intent Actions",
    value: "intent_actions",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Intent Action",
  },
  {
    title: "Landing Page Visits",
    value: "landing_page_visits",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
  },
  {
    title: "Landing Page Views",
    value: "landing_page_views",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Landing Page Visit",
  },
  {
    title: "Leads",
    value: "leads",
    calculationType: TYPE_SUM,
    formatter: formatters.integerFormat,
    kpiVolumeTrigger: "Lead Gen",
  },
  {
    title: "Link Clicks",
    value: "link_clicks",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Link Click",
  },
  {
    title: "Local Action",
    value: "local_action",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Local Action",
  },
  {
    title: "Page Likes",
    value: "page_likes",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Page Like",
  },
  {
    title: "Purchase Value",
    value: "purchase_value",
    formatter: formatters.currencyFormat,
    calculationType: TYPE_SUM,
  },
  {
    title: "Purchases",
    value: "purchases",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Purchase",
  },
  {
    title: "ROAS",
    value: "roas",
    formatter: formatters.numberFixedFormat,
    kpiTrigger: "ROAS",
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "Site Action",
    value: "site_action",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Website Action",
  },
  {
    title: "Store Visits",
    value: "store_visits",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Store Visit",
  },
  {
    title: "Submissions/Entries",
    value: "submission_entries",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Submission / Entry",
  },
  {
    title: "VCR",
    value: "vcr",
    formatter: formatters.percentFormat,
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "Video Views",
    value: "video_views",
    formatter: formatters.integerFormat,
    calculationType: TYPE_SUM,
    kpiVolumeTrigger: "Video View",
  },
  {
    title: "Budget",
    value: "channel_budget",
    formatter: formatters.formattedCurrencyNoFraction,
    calculationType: TYPE_SUM,
  },
];
